/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-var-requires */
import { Component, Mixins, Prop } from 'vue-property-decorator';
import { RouterV2Enum } from '@/router/router-names';
import routerHelper from '@/shared/utils/routerHelper';
// import QuestionBox from '@/components/question-box';
import { session } from '@/shared/utils/storage';
import platform from '@/shared/utils/platform';
import { jumpToMarketPage } from '@/shared/utils/jumpToRedirectPage';
import ApllyCommonHeader from '../apply-common-header';
import MyMixns from '../mixins';

const style = require('./index.module.scss') as Dictionary;

/** 猜你想问 */
const QuestionBox = () => import(
  /* webpackChunkName: "question-box" */'@/components/question-box'
// eslint-disable-next-line @typescript-eslint/no-explicit-any
) as any;

@Component({
  name: 'ApplyReject',
})
export default class ApplyReject extends Mixins(MyMixns) {
  /** 是否外采授信成功 */
  @Prop(String) readonly outOrder!: boolean;

  private onBackHome() {
    this.$ubtPageButton('臻有钱_审核不通过_回到首页');

    if (this.isSourceRideCard) {
      this.$router.replace({
        path: RouterV2Enum.home,
      });
    } else {
      routerHelper.backHome();
    }
  }

  // 去看看其他产品
  private onMarketList() {
    this.$ubtPageButton(
      '臻有钱_审核不通过_去看看其他产品',
      'channelSource',
      'preApplyResult',
    );

    if (!session.get('myProfile')) {
      session.set('PreApplyResult', true);
    }

    this.$router.replace({
      path: '/home',
      query: {
        channelSource: 'preApplyResult',
      },
    });
  }

  private goDownload() {
    this.$ubtPageButton('finance_drawResultFail_findNew');
    jumpToMarketPage();
  }

  private render() {
    return (
      <div class={style.applyReject}>
        <div class={style.content}>
          <ApllyCommonHeader
            contentText={'审核不通过'}
            contentDescText={platform.isAlipayMini || platform.isDingTalk
              ? ['抱歉，您的资质暂不符合要求']
              : ['抱歉，您的资质暂不符合要求', '别气馁，快去试试其他产品吧～']}
            applyReject={true}
          />


            {/* 猜你想问 */}
            {!this.outOrder && (
              <QuestionBox
                class={style.questionBox}
                keyCode='AppFinanceH5Web.PreApplyFailed.QuestionBoxData'
              />
            )}

            {this.outOrder && (
              <div
                class={style.download}
                onClick={this.goDownload.bind(this)}
              >申请新额度</div>
            )}
        </div>
      </div>
    );
  }
}
